import { render, staticRenderFns } from "./VirtualTour.vue?vue&type=template&id=298b6ea4&scoped=true&"
import script from "./VirtualTour.vue?vue&type=script&lang=js&"
export * from "./VirtualTour.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTour.vue?vue&type=style&index=0&id=298b6ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b6ea4",
  null
  
)

export default component.exports